(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ComercioDetailController', ComercioDetailController);

    ComercioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Comercio', 'Pv', 'Aeropuerto', 'Rubro', 'Moneda'];

    function ComercioDetailController($scope, $rootScope, $stateParams, previousState, entity, Comercio, Pv, Aeropuerto, Rubro, Moneda) {
        var vm = this;

        vm.comercio = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:comercioUpdate', function(event, result) {
            vm.comercio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
